import {
  FETCH_REMINDERS_START,
  FETCH_REMINDERS_SUCCESS,
  ADD_REMINDER_START,
  ADD_REMINDER_SUCCESS,
  EDIT_REMINDER_START,
  EDIT_REMINDER_SUCCESS,
  DELETE_REMINDER_START,
  DELETE_REMINDER_SUCCESS,
  REMINDERS_API_ERROR,
  CLEAR_REMINDERS_MODAL,
} from "./actionTypes";

const initialState = {
  reminders: [],
  loading: false,
  totalDocs: 0,
  totalPages: 1,
  page: 1,
  limit: 10,
  addLoading: false,
  editLoading: false,
  deleteLoading: false,
  modalClearCounter: 0,
  deleteClearCounter: 0,
  error: null,
};

const remindersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REMINDERS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REMINDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        reminders: action.payload.docs || [],
        totalDocs: action.payload.totalDocs || 0,
        totalPages: action.payload.totalPages || 1,
        page: action.payload.page || 1,
        limit: action.payload.limit || 10,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        nextPage: action.payload.nextPage || null,
        prevPage: action.payload.prevPage || null,
      };
    case ADD_REMINDER_START:
      return {
        ...state,
        addLoading: true,
        error: null,
      };
    case ADD_REMINDER_SUCCESS:
      return {
        ...state,
        addLoading: false,
        modalClearCounter: state.modalClearCounter + 1,
      };
    case EDIT_REMINDER_START:
      return {
        ...state,
        editLoading: true,
        error: null,
      };
    case EDIT_REMINDER_SUCCESS:
      return {
        ...state,
        editLoading: false,
        modalClearCounter: state.modalClearCounter + 1,
        reminders: state.reminders.map((r) => {
          if (r._id !== action.payload._id) return r;
          const updated = {
            ...r,
            ...action.payload,
          };
          if ((!action.payload.customerId || typeof action.payload.customerId === "string") && typeof r.customerId === "object") {
            updated.customerId = r.customerId;
          }
          if ((!action.payload.createdBy || typeof action.payload.createdBy === "string") && typeof r.createdBy === "object") {
            updated.createdBy = r.createdBy;
          }
          return updated;
        }),
      };
    case DELETE_REMINDER_START:
      return {
        ...state,
        deleteLoading: true,
        error: null,
      };
    case DELETE_REMINDER_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteClearCounter: state.deleteClearCounter + 1,
      };
    case REMINDERS_API_ERROR:
      return {
        ...state,
        loading: false,
        addLoading: false,
        editLoading: false,
        deleteLoading: false,
        error: action.payload,
      };
    case CLEAR_REMINDERS_MODAL:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export default remindersReducer;
